module.exports = __webpack_public_path__ + "static/who-we-are.7831023f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/who-we-are.svg
// module id = 3713
// module chunks = 35783957827783